import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const purchases = [{
  name: 'Juan',
  city: 'Córdoba'
}, {
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Carlos',
  city: 'Rosario'
}, {
  name: 'Fernanda',
  city: 'Mendoza'
}, {
  name: 'Diego',
  city: 'Santa Fe'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Martín',
  city: 'La Plata'
}, {
  name: 'Lucía',
  city: 'Mar del Plata'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<{
    name: string;
    city: string;
  } | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showPopup, 8000);
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 15000 + 15000);
      }
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-14">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-center gap-3 max-w-[300px]" data-id="element-15">
          <div className="bg-green-100 p-2 rounded-full text-green-600 shrink-0" data-id="element-16">
            <CheckCircle2 size={24} data-id="element-17" />
          </div>
          <div data-id="element-18">
            <p className="text-xs text-gray-500 mb-0.5" data-id="element-19">
              Alguien acaba de comprar
            </p>
            <p className="font-bold text-navy text-sm leading-tight" data-id="element-20">
              {currentPurchase.name} de {currentPurchase.city}
            </p>
            <p className="text-xs text-electric font-semibold mt-1" data-id="element-21">
              Megapack Élite EF360
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}